import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { SubscriptionItemService } from 'src/app/core/services/subscription-item.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { OOVenue } from 'src/app/shared/models/oo-venue';

@Component({
	selector: 'app-subscription',
	templateUrl: './subscription.component.html',
	styleUrls: ['./subscription.scss'],
})
export class SubscriptionComponent implements OnInit, OnDestroy {
	displayCart: boolean = false;

	ooVenue: OOVenue;

	ooVenueSubscription: Subscription;

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		public customerService: CustomerService,
		private activatedRoute: ActivatedRoute,
		public subscriptionItemService: SubscriptionItemService
	) {}
	ngOnDestroy(): void {
		this.ooVenueSubscription.unsubscribe();
	}

	ngOnInit(): void {
		const venueKey = +this.activatedRoute.snapshot.paramMap.get('venueKey');
		this.venueService.subscriptionOOcanvas.subscribe((canvas) => {
			if (canvas.length > 0) {
				this.venueService.subscriptionMenuBuild();
			}
		});

		this.ooVenueSubscription = this.venueService.subscriptionOOvenue.subscribe((data) => {
			this.ooVenue = data;
		});
		this.init(venueKey);
	}

	async init(venueKey) {
		await this.venueService.initVenue(venueKey);
	}

	onGesture(action: string) {
		console.log(action);
	}
}
